export const HomeVariables = {
  seo: {
    title: "Filmes e séries online e Paulistão 2025 | UOL Play",
    description: "Paulistão 2025 é no UOL Play! Aqui você encontra filmes, séries, desenhos, produções originais do UOL e canais com programação ao vivo da History Channel, Sony, Warner e AXN, assim como séries da Paramount+ e HBO Max. Além disso, assista a diversos campeonatos de esporte ao vivo: UFC Fight Pass ao vivo, futebol e Fórmula 1 no BandSports e muito mais.",
    url: "https://play.uol.com.br/",
    canonical: "https://play.uol.com.br/",
    thumbnail: "https://cdn.imguol.com.br/p/pp/uol-play/redes-sociais.jpg",
  },

  header: {
    img: `https://cdn.imguol.com.br/p/pp/uol-play/logo_UOL_Final.svg`,
    title: {
      h1: `Um universo`,
      span: `de conteúdos`,
    },
    description: {
      text: `No UOL Play você encontra filmes, séries, desenhos, shows, canais ao vivo e muito mais`,
      span: ``,
    },
    ctaText: `Veja os planos`,
    blackFriday: {
      bannerDesktop: `https://cdn.imguol.com.br/p/pp/uol-play/blackFriday/desktop/Logo-bf-banner.png`,
      bannerMobile: `https://cdn.imguol.com.br/p/pp/uol-play/blackFriday/mobile/Logo-bf-banner.png`,
    },
  },
  partners: {
    title: `Confira os canais UOL Play disponíveis para você`,
  },
  plusChannel: {
    title: `Estamos trabalhando para oferecer uma experiência incrível para você e por isso as novidades não param de chegar: mais filmes, séries, documentários, esportes ao vivo e shows para assistir quando e onde quiser!`,
    img: `https://cdn.imguol.com.br/p/pp/uol-play/frase.png`,
    imgAlt: `Canais estão chegando`,
    imgTitle: `Canais estão chegando`,
  },
  whySubscribe: {
    title: {
      h2: `Por que assinar o`,
      span: `UOL Play?`,
    },
    items: [
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/icons/chair.svg`,
        title: `+ de 5.000 horas de conteúdo`,
        description: `UOL Play é série, filme, esporte, desenho e muito mais! Tudo em um só lugar.`,
        altText: `icon Cadeira`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/icons/popcorn.svg`,
        title: `Sua alternativa para TV a cabo`,
        description: `Escolha o combo que mais combina com você e pague um preço justo por isto.`,
        altText: `icon Cadeira`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/icons/devices.png`,
        title: `4 perfis, 2 telas e muita diversão!`,
        description: `Assim a família toda tem liberdade para assistir ao seu programa favorito.`,
        altText: `icon Cadeira`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/icons/savings.svg`,
        title: `Cancele quando quiser`,
        description: `Sem pagar nenhuma taxa de cancelamento e sem burocracia. Isto é UOL Play!`,
        altText: `icon Cadeira`,
      },
    ],
  },
  catalog: [
    {
      img: `https://cdn.imguol.com.br/p/pp/uol-play/catalogImages/conto.webp`,
      title: `O Conto da Aia`,
      channel: ``,
      category: `Séries`,
    },
    {
      img: `https://cdn.imguol.com.br/p/pp/uol-play/catalogImages/imagem_02.png`,
      title: `Futebol ao vivo`,
      channel: ``,
      category: `Esportes`,
    },
    {
      img: `https://cdn.imguol.com.br/p/pp/uol-play/catalogImages/cinquentatons.webp`,
      title: `Cinquenta Tons`,
      channel: ``,
      category: `Filmes`,
    },
    {
      img: `https://cdn.imguol.com.br/p/pp/uol-play/catalogImages/imagem_04.png`,
      title: `De Férias com o Ex - A Ressaca`,
      channel: ``,
      category: `Reality Show`,
    },
  ],
  watch: {
    title: {
      h3: `Assista`,
      span: `onde e quando quiser`,
    },
    img: {
      url: `https://cdn.imguol.com.br/p/pp/uol-play/imagem-dispositivos.png`,
      altText: `Dispositivos`,
    },
    items: [
      {
        title: `Computador`,
      },
      {
        title: `Celular`,
      },
      {
        title: `Tablet`,
      },
      {
        title: `Aplicativo (Android e iOS)`,
      },
      {
        title: `Smart TV`,
      },
    ],
  },

  planos: {
    title: `Escolha o combo que mais combina com você!`,
    footer: ``,
  },

  canaisAdicionais: {
    title: {
      part1: `Os canais que você mais `,
      part2: `ama em um só lugar`,
    },
    description: {
      part1: `Assinante UOL Play pode contratar os`,
      part2: `canais adicionais abaixo:`,
    },
    backgroundDesktop: `https://cdn.imguol.com.br/p/pp/uol-play/canais-adicionais/fundo-desktop.webp`,
    backgroundMobile: `https://cdn.imguol.com.br/p/pp/uol-play/canais-adicionais/fundo-mobile.webp`,
    textCta: `Escolha seu combo`,
  },

  faq: {
    title: {
      h2: `Dúvidas`,
      span: `frequentes`,
    },
    description: `Estamos aqui para ajudar, se você ainda tem dúvidas sobre o produto entre em contato com a nossa Central de Atendimento.`,
    phone1: `4003-2002`,
    location1: `Capitais e regiões metropolitanas`,
    phone2: `0800 771 7774`,
    location2: `Demais localidades`,
    helpDescription: `Ainda tem alguma dúvida? Acesse nossa página de`,
    questions: [
      // {
      //   title: `Como faço para ganhar o álbum da Copa do Mundo 2022?
      //   `,
      //   answer: `Para aproveitar a promoção e ganhar o seu álbum de figurinhas oficial da Panini da Copa do Mundo FIFA Qatar 2022™ é só
      //   <a href="https://play.uol.com.br/assine?utm_source=faq_organic_panini&utm_medium=faq&utm_campaign=faq_organic_panini" target="_blank">assinar um dos combos do UOL Play</a> <br><br>

      //   Aí é só esperar que, após 9 dias, você receberá um e-mail com instruções de como resgatar o seu álbum com as 11 figurinhas com frete grátis. Aproveite e divirta-se! <br><br>

      //   Ah, a promoção é válida enquanto durar o estoque, para clientes ativos e pagantes, sendo 1 resgate por CPF.`
      // },
      // {
      //   title: `Como aproveitar o "Experimente 7 dias" do UOL Play?`,
      //   answer: `<strong>Veja como funciona:</strong><br><br>
      // 1. Acesse o site do <a href="https://play.uol.com.br/assine?utm_source=faq_organic_experimente-7-dias-acesse-o-site&utm_medium=faq&utm_campaign=faq_organic_experimente-7-dias-acesse-o-site" target="_blank">UOL Play</a>;<br>
      // 2. Escolha seu plano;<br>
      // 3. Clique no botão “Experimente por 7 dias”;<br>
      // 4. Faça seu cadastro e é só dar o Play. <br><br>
      // Se você quiser cancelar o período de experimentação, é necessário fazer o cancelamento em um dos nossos canais <strong>até o período de 7 dias.</strong> <br><br>
      // <strong>Importante:</strong> após o período de 7 dias, caso o cancelamento não seja feito, o valor total do plano que você escolheu será cobrado automaticamente.<br><br>
      // Não perca tempo, <a href="https://play.uol.com.br/assine?utm_source=faq_organic_experimente-7-dia&utm_medium=faq&utm_campaign=faq_organic_experimente-7-dia" target="_blank">experimente UOL Play</a> agora mesmo.<br>`
      // },
      {
        title: `Saiba como aproveitar o UOL Play`,
        answer: `Veja como funciona: <br>
        1 - Acesse o site do <strong> <a href='https://play.uol.com.br/assine?utm_source=faq_organic_experimente-7-dias-acesse-osite&utm_medium=faq&utm_campaign=faq_organic_experimente-7-dias-acesse-o-site' target='_blank'> UOL Play </a></strong> <br>
        2 - Escolha o plano que mais combina com você;<br>
        3 - Clique no botão laranja do combo escolhido”;<br>
        4 - Faça o seu cadastro e pronto, agora é só dar o Play! <br><br>

        Não perca tempo, <strong> experimente <a href='https://play.uol.com.br/assine?utm_source=faq_organic_experimente-7-dias-acesse-osite&utm_medium=faq&utm_campaign=faq_organic_experimente-7-dias-acesse-o-site' target='_blank'> UOL Play </a> </strong> agora mesmo. `,
      },
      {
        title:
          "Posso assistir filmes e séries ao vivo ou na hora que eu quiser?",
        answer: `Sim, na opção on demand é possível selecionar os conteúdos que deseja e assistir na mesma hora, com um simples play. Confira as opções para você se divertir muito!<br><br>
      <strong>ON DEMAND</strong><br><br>
      Nesta modalidade você pode assistir aos conteúdos que mais gosta “sob demanda”, ou seja, na hora que quiser. Basta escolher entre inúmeros filmes, séries, desenhos, músicas e muito mais, sem precisar baixar ou armazenar os conteúdos.<br><br>
      Além de poder ver os conteúdos originais do UOL Play (MOV), você também aproveita filmes e séries de parceiros como Paramount+, Comedy Central e AwesomenessTV.<br><br>
      <strong>AO VIVO</strong><br><br>
      São conteúdos que seguem uma programação diária e você pode assisti-los sempre que estiverem sendo transmitidos. Os canais disponíveis são: Warner Channel, AXN, Sony Channel, Sony Movies, Lifetime, A&E, History, H2, Nickelodeon, Nick Jr., MTV, MTV Live, Comedy Central, Paramount Network, BandSports, Band News, Agro+, Arte 1 e Terraviva.<br><br>
      Viu como o UOL Play é cheio de conteúdos para você assistir online?
      <a href="https://play.uol.com.br/assine?utm_source=faq_organic_filmes-e-serie-a-hora-que-quiser&utm_medium=faq&utm_campaign=faq_organic_filmes-e-serie-a-hora-que-quiser" target="_blank">Assine agora mesmo</a> e faça o login para conferir a programação completa.`,
      },
      {
        title:
          "Vou assistir a toda programação dentro da plataforma do UOL Play?",
        answer: `Grande parte da programação é acessada dentro da própria plataforma UOL Play, é só fazer login e dar o play.<br><br>
      Já para ver conteúdos adicionais, ou conteúdos de parceiros do UOL, é necessário baixar o aplicativo referente ao que deseja ver (não se preocupe, isso é totalmente seguro).<br><br>
      Os conteúdos e seus respectivos aplicativos são os seguintes: <br><br>
      <ul>
      <li>HBO Max: Android ou iOS - <a href="https://play.uol.com.br/como-acessar/hbo?utm_source=faq_organic_programacao-da-plataforma-como-acessar-hbo-max&utm_medium=faq&utm_campaign=faq_organic_programacao-da-plataforma-como-acessar-hbo-max" target="_blank">Veja como acessar</a></li>

      </ul>
      <strong>#Dica <br></strong>
      <strong>Baixe os apps agora mesmo e entre com seu login UOL Play para conferir um universo de conteúdos!</strong> <br><br>
      <strong>Ainda não é assinante? <a href="https://play.uol.com.br/assine?utm_source=faq_organic_programacao-da-plataforma&utm_medium=faq&utm_campaign=faq_organic_programacao-da-plataforma" target="_blank">Assine agora</a> e experimente por 7 dias.</strong>`,
      },
      {
        title:
          "Quais são os conteúdos adicionais que posso adquirir para aumentar o meu combo?",
        answer: `<strong>HBO Max</strong> <br>
    Séries, filmes, produções exclusivas e muito mais! São 15 mil horas de conteúdo para ver onde e quando você quiser. Adicione a <strong>HBO Max</strong> ao seu plano <strong>UOL Play</strong> pelo período de 1 mês gratuitamente e prove o melhor do cinema. Aproveite já!<br><br>

    <strong>Weburn</strong> <br>
    Adicione o Weburn ao seu combo UOL Play para ter acesso a conteúdos fitness exclusivos, com diversos exercícios focados em seus objetivos, seja para praticar em casa, na academia ou ao ar livre. <a href="https://play.uol.com.br/assine?utm_source=faq_organic_aumentar-combo&utm_medium=faq&utm_campaign=faq_organic_aumentar-combo" target="_blank">Turbine já seu plano.</a>`,
      },
      {
        title: "Quais conteúdos eu e minha família podemos ver? ",
        answer: `Fique por dentro de tudo que acontece nas suas séries e programas favoritos. Aqui no UOL Play você tem acesso aos conteúdos AO VIVO dos canais: <br><br>
      <ul>
      <li><strong>Sony Channel:</strong> The Good Doctor, Shark Tank Brasil e muito mais.</li><br>
      <li><strong>AXN:</strong> CSI, NCIS Hawaii, Candice Renoir e outras séries eletrizantes.</li><br>
      <li><strong>BandSports:</strong> Fórmula 1 e diversos programas sobre esportes.</li><br>
      <li><strong>Paramount Network:</strong> O Conto da Aia (The Handmaid's Tale), For Life, Yellowstone e muito mais. </li><br>
      <li><strong>History Channel: </strong>Desafio Sob o Fogo, Trato Feito, Gigante dos Alimentos, Mistérios Revelados, As Máquinas que Mudaram o Mundo, Quem dá Mais?</li><br>
      <li><strong>Warner Channel:</strong> The Big Bang Theory, Riverdale, Legacies, The Flash, Supernatural e outros conteúdos para você e sua família.</li><br>
      <li><strong>Comedy Central:</strong> A Culpa é do Cabral, Todo Mundo Odeia o Chris, Um Maluco no Pedaço, Eu, A Patroa e as Crianças e muito mais para te fazer rir a qualquer momento.</li>
      </ul>`,
      },
      {
        title: "Dúvidas e soluções",
        answer: `Algumas das suas dúvidas podem ser solucionadas pelo nosso <a href="https://play.uol.com.br/como-acessar/?utm_source=faq_organic_duvidas-e-solucoes&utm_medium=faq&utm_campaign=faq_organic_duvidas-e-solucoes" target="_blank">passo a passo de como acessar o UOL Play</a>, você já conhece? Clique no link e confira.
      <br><br>
      Se ainda assim você não encontrou a solução, entre em contato com o nosso <a href="https://play.uol.com.br/como-acessar/?utm_source=faq_organic_duvidas-e-solucoes-sac&utm_medium=faq&utm_campaign=faq_organic_duvidas-e-solucoes-sac" target="_blank">SAC</a> ou através do telefone 4003 2002 (capitais e regiões metropolitanas) ou 0800 771 7774 (demais localidades).`,
        //<br><br><strong>Fale com a gente!</strong> A sua opinião é muito importante para nós. Clique em <strong>“Feedback”</strong>, na caixa que aparece ao lado, e deixe seus <strong>comentários, elogios, críticas ou sugestões</strong> sobre a sua experiencia com o UOL Play.
      },
      {
        title: "Quais planos posso contratar no UOL Play?",
        answer: `Separamos dois planos incríveis pensando em oferecer entretenimento, informação e diversão para você e sua família, confira:
      <br><br>
      <strong>Plano Light:</strong> oferecemos o melhor do on demand, que são os conteúdos sob demanda (que você pode assistir quando quiser). O Plano Light é ideal para você que vive na correria do dia a dia e gosta de assistir filmes e séries que escolher, a qualquer momento. <br><br>
      <strong>Plano Cinema:</strong> se você não gosta de perder as suas séries favoritas, então esse é o seu plano ideal, porque aqui você encontra tanto conteúdos ao vivo quanto on demand. Sempre que você quiser, é só acessar o aplicativo do UOL Play para conferir a programação que está passando. Tem conteúdos da Sony Channel, Sony Movies, AXN, MTV, History Channel, Warner Channel, BandSports e muito mais.<br><br>
      E mais! Sempre que quiser, você pode turbinar o seu combo com os nossos canais adicionais. <br><br>
      Tá vendo como o UOL pensa em tudo? <a href="https://play.uol.com.br/assine?utm_source=faq_organic_quais-planos-posso-contratar&utm_medium=faq&utm_campaign=faq_organic_quais-planos-posso-contratar" target="_blank">Assine online</a> e não perca mais um minuto.`,
        // <strong>Plano Família:</strong> prepara a pipoca, porque neste combo do UOL Play, que inclui conteúdos on demand e ao vivo, a diversão é garantida. Você vai conferir séries infantis como Cocoricó, muita cultura, com filmes selecionados do Petra Belas Artes, música boa com o Brasil Jazz Sinfônica, além dos melhores campeonatos de futebol. <br><br></br>
      },
      {
        title:
          "Você sabia que pode alugar filmes no UOL Play mesmo sem ser assinante? ",
        answer: `É isso mesmo! O cardápio de filmes do UOL Play é recheado de conteúdos e pode ser consumido também por quem ainda não é assinante. Viu um filme que gostou e quer alugar agora mesmo? É fácil! Basta conferir os filmes disponíveis e aproveitar a diversão.<br><br>
      <strong>Confira a próxima dica para saber mais.</strong>`,
      },
      {
        title: "Como posso alugar os filmes avulsos no UOL Play?",
        answer: `Alugar um dos nossos filmes do nosso catálogo é fácil e prático! Basta seguir os passos abaixo:<br><br>
      <ol>
      <li>Selecione o filme que deseja assistir;</li>
      <li>Caso você seja cliente UOL Play, basta fazer o seu login. Se não, é só selecionar a opção ALUGUE AGORA;</li>
      <li>Você será direcionado para outra tela para preencher o seu login (caso seja cliente UOL Play) ou para você realizar seu cadastro, caso não seja. <strong>Dica:</strong> antes de mais nada, já deixe o seu documento e cartão de crédito separados para ganhar tempo; </li>
      <li>Preencha os seus dados cadastrais e as informações de pagamento. Após a confirmação do aluguel, o filme selecionado já estará disponível para você assistir.</li>
      </ol>
      <strong>Atenção:</strong> o filme fica disponível por 48 horas em todos os perfis. </br>
      <a href="https://play.uol.com.br/alugue?utm_source=faq_organic_alugar-filmes&utm_medium=faq&utm_campaign=faq_organic_alugar-filmes " target="_blank">Alugue agora mesmo.</a> `,
      },
      {
        title: "Como posso controlar os conteúdos que meus filhos veem?",
        answer: `Com a função Controle Parental você consegue criar um perfil infantil para garantir mais segurança sobre os conteúdos que a criançada assiste. Siga os passos para criar: <br><br>
      <ol>
      <li>Acesse “Minha conta”; </li>
      <li>Clique em “Criar perfil”; </li>
      <li>Selecione a faixa etária adequada, escolhendo entre: L (livre)/10/12/14/16/18 anos;</li>
      <li>Clique em “Salvar” e pronto, agora você já tem um perfil com restrição de programação.</li>
      </ol>
      Agora seus filhos podem se entreter e se divertir com segurança. `,
      },
      {
        title: "Como cancelar o UOL Play?",
        answer: `Podemos te ajudar a cancelar de forma prática, fácil e online. Confira: <br><br>
        <strong>PELO SITE:</strong>
        <ol>
        <li>Acesse o <a href="https://play.uol.com.br/assine?utm_source=faq_organic_como-cancelar&utm_medium=faq&utm_campaign=faq_organic_como-cancelar" target="_blank"> site do UOL Play</a> através do navegador ou do seu celular; </li>
        <li>Selecione “Minha Conta”; </li>
        <li>Clique em “Cancelar assinatura”;</li>
        <li>Siga com a sua solicitação e pronto, sua assinatura estará cancelada.</li>
        </ol>

        <strong>PELO APP: (Somente Android)</strong> <br>
        Acesse o APP > MINHA CONTA > CANCELAR ASSINATURA e pronto, você será direcionado à página de conclusão do cancelamento. <br><br>

        <strong>PELO APP: (Somente iOS)</strong> <br>
        O cancelamento deve ser feito através da página web do celular ou desktop, estamos trabalhando para aperfeiçoar o cancelamento via APP para clientes iOS. <br><br>

        <strong>PELO SAC:</strong> <br>
        Você também pode realizar o seu cancelamento através do nosso <a href="https://sac.uol.com.br/?utm_source=faq_organic_como-cancelar-sac&utm_medium=faq&utm_campaign=faq_organic_como-cancelar-sac" target="_blank">SAC</a> com um dos nossos atendentes. `,
      },
    ],
    helpLink: {
      text: `Ajuda`,
      url: `https://sac.uol.com.br/ajuda/category/uol-play?utm_source=UPL_conheca&utm_medium=ajuda-acima-footer&utm_campaign=pg_de_vendas&utm_content=upl-ajuda`,
    },
  },

  vantagens: {
    title: {
      h3: `Cliente UOL sempre tem`,
      span: `mais vantagens`,
    },
    items: [
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/icon_uoly.png`,
        imgAltText: `UOL`,
        title: `Suporte 24/7`,
        description: `Uma equipe sempre pronta para te ajudar no que você precisar.`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/icon_clubeuol.svg`,
        title: `Clube UOL`,
        imgAltText: `Clube UOL`,
        description: `Ofertas exclusivas em lojas online, restaurantes e muito mais.`,
        linkText: `Ver mais`,
        linkUrl: `https://clube.uol.com.br/?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-clube&utm_content=upl-clube`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/icon_celular.svg`,
        title: `Aplicativo Meu UOL`,
        imgAltText: `App Meu UOL`,
        description: `Feito para você gerenciar seus produtos UOL.`,
        linkText: `Baixar app`,
        linkUrl: `https://produtos.uol.com.br/appmeuuol?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-appmeuuol&utm_content=upl-appmeuuol`,
      },
      {
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/icon_skeelo.svg`,
        title: `Skeelo`,
        imgAltText: `Skeelo`,
        description: `Milhares de livros digitais para você ler pelo celular. Para ganhar um e-book todo mês, baixe o app.`,
      },
    ],
  },
  socialMedia: {
    description: `Siga nossos perfis nas redes sociais e fique por dentro dos lançamentos, dicas de novos filmes e séries e
        muito mais.`,
    items: [
      {
        name: `Instagram`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_instagram.svg`,
        url: `https://www.instagram.com/uol_play?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-ig&utm_content=upl-ig`,
      },
      {
        name: `Facebook`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_facebook.svg`,
        url: `https://www.facebook.com/uolplay?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-fb&utm_content=upl-fb`,
      },
      {
        name: `Youtube`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_youtube.svg`,
        url: `https://www.youtube.com/channel/UCHSpTrCaGVi2TrZiXrKJsKQ?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-yt&utm_content=upl-yt`,
      },
      {
        name: `Twitter`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_twitter.svg`,
        url: `https://twitter.com/uol_play`,
      },
      {
        name: `Tiktok`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_tiktok.svg`,
        url: `https://www.tiktok.com/@uol_play`,
      },
      {
        name: `Pinterest`,
        img: `https://cdn.imguol.com.br/p/pp/uol-play/logos-vantagens/btn_pinterest.svg`,
        url: `https://br.pinterest.com/uol/uol-play/`,
      },
    ],
  },
};

export default HomeVariables;
